import type { ResolvedColumn } from './column';

export interface ColumnGroup<T> {
    header?: string;
    columns: ResolvedColumn<T>[];
}

export function buildColumnGroups<T>(
    columns: ResolvedColumn<T>[],
): ColumnGroup<T>[] {
    const groups: ColumnGroup<T>[] = [];
    const byHeader = new Map<string, ColumnGroup<T>>();
    columns.forEach((col) => {
        const key = col.groupHeader;
        const existing = key === undefined ? undefined : byHeader.get(key);
        if (existing) {
            existing.columns.push(col);
            return;
        }
        const group: ColumnGroup<T> =
            key === undefined
                ? { columns: [col] }
                : { header: key, columns: [col] };
        if (key !== undefined) byHeader.set(key, group);
        groups.push(group);
    });
    return groups;
}
